'use strict';

// Consumed by Skeleton.web, skeleton size mapper
const avatarSkeletonSizes = {
    xsmall: {
        width: 40,
        height: 40
    },
    small: {
        width: 56,
        height: 56
    },
    medium: {
        width: 80,
        height: 80
    },
    large: {
        width: 120,
        height: 120
    },
    xlarge: {
        width: 160,
        height: 160
    }
};

exports.avatarSkeletonSizes = avatarSkeletonSizes;
//# sourceMappingURL=Avatar.web.styles.cjs.map
